import { Tooltip } from '@material-ui/core';
import {
  AccountIcon,
  BriefcaseIcon,
  CreditCardIcon,
  GearIcon,
  InformationIcon,
  InvoiceIcon,
  OfficeIcon,
  PadlockIcon,
} from '@room-match/shared-ui-components';
import {
  BillingInformation,
  BillingInvoices,
  ChangePassword,
  ContactInformation,
  GeneralInformation,
  JobPreferences,
  ManageAccount,
  PaymentMethods,
  Plans,
} from 'components';
import React, { useMemo } from 'react';
import { useHistory, useParams } from 'react-router';
import { ROUTES } from 'shared/constants/ROUTES';
import { useUser } from 'shared/hooks';
import { useSetHeaderBack, useSetHeaderTitle } from 'shared/hooks/useSetHeader';
import { ls } from 'shared/utils/ls';
import { Content, CustomTabs, MainContainer, TabItem } from './Settings.styles';

const tabs = [
  {
    name: 'general_information',
    icon: <InformationIcon />,
    header: 'General Information',
    component: <GeneralInformation />,
    disabled: false,
  },
  {
    name: 'contact_information',
    icon: <AccountIcon />,
    header: 'Contact Information',
    component: <ContactInformation />,
    disabled: false,
  },
  {
    name: 'how_you_will_be_paid',
    icon: <OfficeIcon />,
    header: 'How You Will Be Paid',
    component: <BillingInformation />,
    disabled: false,
  },
  {
    name: 'job_preferences',
    icon: <BriefcaseIcon />,
    header: 'Job Preferences',
    component: <JobPreferences />,
    disabled: true,
  },
  {
    name: 'change_password',
    icon: <PadlockIcon />,
    header: 'Change Password',
    component: <ChangePassword />,
    disabled: false,
  },
  {
    name: 'plans',
    icon: <img src="/casting-logo.png" style={{ width: 40, marginTop: 5, marginRight: 10, marginLeft: -5 }} />,
    header: 'Plans',
    component: <div></div>,
    disabled: false,
  },
  {
    name: 'payment_methods',
    icon: <CreditCardIcon />,
    header: 'Payment Methods',
    component: <PaymentMethods />,
    disabled: true,
  },
  {
    name: 'billing_invoices',
    icon: <InvoiceIcon />,
    header: 'Billing / Invoices',
    component: <BillingInvoices />,
    disabled: true,
  },
  {
    name: 'manage_account',
    icon: <GearIcon />,
    header: 'Manage Account',
    component: <ManageAccount />,
    disabled: false,
  },
];

const hideTabs = [
  'how_you_will_be_paid',
  'job_preferences',
  'change_password',
  'plans',
  'payment_methods',
  'billing_invoices',
  'manage_account',
];

const Settings = () => {
  const { getLS } = ls();
  useSetHeaderTitle(`My Account`);
  useSetHeaderBack(false);
  const { isUserTypeGuardian, isUserTypeTalent } = useUser();
  const { tab } = useParams() as { tab: string };
  const history = useHistory();
  const getActiveTab = useMemo(() => {
    return tabs.find((_tab) => _tab.name === tab)?.component;
  }, [tab]);
  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    history.push(`${ROUTES.TALENT.SETTINGS}/${newValue}`);
  };
  const shouldNotBeHidden = !getLS('guardian_token') || isUserTypeGuardian;

  return (
    <MainContainer>
      <CustomTabs
        orientation="vertical"
        value={tab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs
          .filter((tab) => {
            if (shouldNotBeHidden) return tab;
            return isUserTypeTalent && hideTabs.indexOf(tab.name) === -1;
          })
          .map((tab, index) =>
            tab.disabled ? (
              <Tooltip title={'Coming Soon'} placement="right">
                <span>
                  <TabItem
                    icon={tab.icon}
                    key={index}
                    label={tab.header}
                    disabled={tab.disabled}
                    value={tab.name}
                    style={{ textTransform: 'capitalize' }}
                  />
                </span>
              </Tooltip>
            ) : (
              <TabItem
                icon={tab.icon}
                key={index}
                label={tab.header}
                disabled={tab.disabled}
                value={tab.name}
                style={{ textTransform: 'capitalize' }}
              />
            ),
          )}
      </CustomTabs>
      {tab === 'plans' ? <Plans /> : <Content>{getActiveTab}</Content>}
    </MainContainer>
  );
};

export default Settings;
